module.exports = ".order-feedback-container {\n  padding: 28px 30%;\n  background-color: #F4F5F8;\n  min-height: 100vh; }\n"